/* SET STATE */
export const SET_STATE_LABREQUESTTRACKING = "SET_STATE_LABREQUESTTRACKING"

/* LABREQUESTTRACKINGS */
export const GET_LABREQUESTTRACKINGS = "GET_LABREQUESTTRACKINGS"
export const GET_LABREQUESTTRACKINGS_SUCCESS = "GET_LABREQUESTTRACKINGS_SUCCESS"
export const GET_LABREQUESTTRACKINGS_FAIL = "GET_LABREQUESTTRACKINGS_FAIL"

/* LABREQUESTTRACKING */
export const GET_LABREQUESTTRACKING = "GET_LABREQUESTTRACKING"
export const GET_LABREQUESTTRACKING_SUCCESS = "GET_LABREQUESTTRACKING_SUCCESS"
export const GET_LABREQUESTTRACKING_FAIL = "GET_LABREQUESTTRACKING_FAIL"

/**
 * ADD LABREQUESTTRACKING
 */
 export const ADD_NEW_LABREQUESTTRACKING = "ADD_NEW_LABREQUESTTRACKING"
 export const ADD_LABREQUESTTRACKING_SUCCESS = "ADD_LABREQUESTTRACKING_SUCCESS"
 export const ADD_LABREQUESTTRACKING_FAIL = "ADD_LABREQUESTTRACKING_FAIL"

 /**
 * UPDATE LABREQUESTTRACKING
 */
export const UPDATE_LABREQUESTTRACKING = "UPDATE_LABREQUESTTRACKING"
export const UPDATE_LABREQUESTTRACKING_SUCCESS = "UPDATE_LABREQUESTTRACKING_SUCCESS"
export const UPDATE_LABREQUESTTRACKING_FAIL = "UPDATE_LABREQUESTTRACKING_FAIL"

/**
 * DELETE LABREQUESTTRACKING
 */
export const DELETE_LABREQUESTTRACKING = "DELETE_LABREQUESTTRACKING"
export const DELETE_LABREQUESTTRACKING_SUCCESS = "DELETE_LABREQUESTTRACKING_SUCCESS"
export const DELETE_LABREQUESTTRACKING_FAIL = "DELETE_LABREQUESTTRACKING_FAIL"
